import request from './request';

export default {
	async login(email) {
		const res = await request.post('/app/auth/login', { email });
		return res;
	},
	async getCasUrl(query) {
		const res = await request.get('/app/auth/cas/url', query);
		return res;
	},
	async casAuth(body) {
		const res = await request.post('/app/auth/cas/auth', body);
		return res;
	},
	async logout() {
		const res = await request.post('/app/auth/logout');
		return res;
	}
};
